import { connect } from 'react-redux';
import { getPanoramaNodeById } from '../../actions/StreetViewPage';
import StreetViewPage from './StreetViewPage';

const mapsStateToProps = state => ({
	pageProps: state.streetViewPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getPanoramaNodeById(options) {
		dispatch(getPanoramaNodeById(options));
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(StreetViewPage);
